export default __webpack_public_path__ + "static/media/346.ae0a33a8.png";